

var isOnline = location.host.indexOf('quiz.mechallenge.asia') != -1;
var baseUrl = isOnline ? '//api.mechallenge.asia/index.php?r=' : '//api.mechallenge.asia/index.php?r=';
var baseHomeUrl = isOnline ? 'https://quiz.mechallenge.asia' : 'https://quiz.mechallenge.asia';

export default {
    apiHost: baseUrl,
    baseHomeUrl:baseHomeUrl
}



// WEBPACK FOOTER //
// ./src/config.js